import { fetch } from '@ixigo/shell/fetch';

import type { Transaction, WalletResponse } from '../types';

export async function getTransactions(): Promise<ReadonlyArray<Transaction>> {
	try {
		const response = await fetch.get(
			'api/v3/ixigo-money/wallet?showTransaction=true',
			{ throwHttpErrors: false },
		);

		if (!response.ok) return [];

		const data: WalletResponse = await response.json();
		return data.data.transactions ?? [];
	} catch {
		return [];
	}
}
